import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPopularMovies, IRecommendedMovies, MoviesCountForTab } from './types';

export interface MagicMovieState {
  userName: string;
  userId: string;
  avatar: number;
  popularMovies: IPopularMovies;
  recommendedMovies: IRecommendedMovies;
  selectedMovies: string[];
  selectedMoviesForTab: any;
}

const initialState: MagicMovieState = {
  userName: '',
  userId: '',
  avatar: 0,
  popularMovies: {},
  recommendedMovies: {},
  selectedMovies: [],
  selectedMoviesForTab: {},
};

export const magicMovieSlice = createSlice({
  name: 'MagicMovie',
  initialState,
  reducers: {
    setMagicMovieUserName: (state, action: PayloadAction<{ userName: string }>) => {
      state.userName = action.payload.userName;
    },
    setMagicMovieUserId: (state, action: PayloadAction<{ userId: string }>) => {
      state.userId = action.payload.userId;
    },
    setMagicMovieAvatar: (state, action: PayloadAction<{ avatarNumber: number }>) => {
      state.avatar = action.payload.avatarNumber;
    },
    setMagicMoviePopularMovies: (state, action: PayloadAction<{ popularMovies: IPopularMovies }>) => {
      state.popularMovies = { ...state.popularMovies, ...action.payload.popularMovies };
    },
    setMagicMovieRecommendedMovies: (state, action: PayloadAction<{ recommendedMovies: IRecommendedMovies }>) => {
      state.recommendedMovies = { ...state.recommendedMovies, ...action.payload.recommendedMovies };
    },
    setMagicMovieSelectedMovies: (state, action: PayloadAction<{ selectedMovies: string[] }>) => {
      state.selectedMovies = action.payload.selectedMovies;
    },
    setMagicMovieSelectedMoviesForTab: (state, action: PayloadAction<{ selectedMoviesForTab: MoviesCountForTab }>) => {
      state.selectedMoviesForTab = { ...state.selectedMoviesForTab, ...action.payload.selectedMoviesForTab };
    },
  },
});

export const {
  setMagicMovieUserName,
  setMagicMovieUserId,
  setMagicMovieAvatar,
  setMagicMoviePopularMovies,
  setMagicMovieRecommendedMovies,
  setMagicMovieSelectedMovies,
  setMagicMovieSelectedMoviesForTab,
} = magicMovieSlice.actions;

export default magicMovieSlice.reducer;
